import {
    GET_ALL_USER_DEPARTMENT_REQUEST, GET_ALL_USER_DEPARTMENT_ERROR, GET_ALL_USER_DEPARTMENT_SUCCESS,
    ADD_ADMIN_DEPARTMENT_REQUEST, ADD_ADMIN_DEPARTMENT_SUCCESS, ADD_ADMIN_DEPARTMENT_ERROR,
    UPDATE_ADMIN_DEPARTMENT_REQUEST, UPDATE_ADMIN_DEPARTMENT_SUCCESS, UPDATE_ADMIN_DEPARTMENT_ERROR,
    DELETE_ADMIN_DEPARTMENT_REQUEST, DELETE_ADMIN_DEPARTMENT_SUCCESS, DELETE_ADMIN_DEPARTMENT_ERROR,
} from "../actions/types";


export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_ALL_USER_DEPARTMENT_REQUEST:
        return {
          loading: true,
        };
      case GET_ALL_USER_DEPARTMENT_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_ALL_USER_DEPARTMENT_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
        case ADD_ADMIN_DEPARTMENT_REQUEST:
          return {
              loading: true,
          };
      case ADD_ADMIN_DEPARTMENT_SUCCESS:
          return {
              ...state,
              loading: false,
              payload: [payload],
          };
      case ADD_ADMIN_DEPARTMENT_ERROR:
          return {
              ...state,
              loading: false
          };
      case DELETE_ADMIN_DEPARTMENT_REQUEST:
          return {
              loading: true,
          };
      case DELETE_ADMIN_DEPARTMENT_SUCCESS:
          return {
              ...state,
              loading: false,
              payload: [payload],
          };
      case DELETE_ADMIN_DEPARTMENT_ERROR:
          return {
              ...state,
              loading: false
          };
      case UPDATE_ADMIN_DEPARTMENT_REQUEST:
          return {
              loading: true,
          };
      case UPDATE_ADMIN_DEPARTMENT_SUCCESS:
          return {
              ...state,
              loading: false,
              payload: [payload],
          };
      case UPDATE_ADMIN_DEPARTMENT_ERROR:
          return {
              ...state,
              loading: false
          };
        
      default:
        return state;
    }
  }
  